import { COLORS } from "../../utils/js/constants";

export default function stockItemStyle(theme) {
    return {
        card: {
            display: 'flex',
            background: COLORS.grey,
            alignItems: 'center',
            margin: '5px 0',
            border: 'solid #a0a0a0 1px',
            padding: 5,
            color: 'white'
        },
        cover: {
            minHeight: 110,
            minWidth: 110,
            borderRadius: '5px',
            flex: 1
        },
        content: {
            padding: 0,
            margin: 0,
            marginLeft: 15,
            flex: 6
        },
        currentStock: {
            color: COLORS.lightYellow,
            display: 'flex',
            fontWeight: 'bold',
            marginBottom: '10px',
            fontSize: '15px',
            justifyContent: 'center',
        },
        productList: {
            display: 'flex',
            flexWrap: 'wrap',
            padding: 0
        },
        listItem: {
            display: "flex",
            alignItems: "center",
            width: '50%',
            margin: 0,
            padding: 0,
            ['& span']: {
                fontWeight: 'bold',
                fontSize: '.8rem'
            },
            ['& p']: {
                fontSize: '.8rem',
                color: 'white',
                marginLeft: 5
            }
        },
        actions: {},
        stockActions: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginBottom: 15
        },
        button: {
            width: 25,
            minWidth: 25,
            height: 25,
            padding: 0,
            borderRadius: '50%',
            background: COLORS.primary,
            ['& span']: {
                fontSize: '0.65rem',
                margin: 'auto'
            },
            ['& span svg']: {
                fontSize: '13px !important',
                color: COLORS.dark,
            },
        },
        stockInput: {
            borderRadius: 5,
            border: 'solid #a0a0a0 1px',
            margin: '0 5px',
            background: 'transparent',
            color: COLORS.lightYellow,
            fontWeight: 'bold',
            textAlign: 'center',
            width: 50,
            height: 25,
            outline: 'none'
        },
        saveBtn: {
            height: 25,
            padding: '0 10px',
            background: COLORS.green2,
            borderRadius: 20,
            ['& span']: {
                fontSize: '0.7rem',
                color: 'white'
            },
            ['& span svg']: {
                fontSize: '13px !important',
                color: COLORS.dark,
                background: COLORS.green,
                padding: 2,
                borderRadius: '50%'
            },
        }
    }
}
